import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const RegimenFiscalExteriorTipo = {

    async Get() {  return await methods.Get("RegimenFiscalExteriorTipo/Get" ); },
    async Post(data) { return await methods.Post("RegimenFiscalExteriorTipo/Post", data) },
    async Put(qs, data) { return await methods.Put("RegimenFiscalExteriorTipo/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("RegimenFiscalExteriorTipo/Delete" + useParamsJson(qs)) }
};

export default RegimenFiscalExteriorTipo;